export default {"src":"/_next/static/media/PEAK.593d4b1f.svg","height":18,"width":18};